export * from "./bed";
